/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { RiShoppingBag3Line } from "react-icons/ri";
import { TiTick } from "react-icons/ti";

const ProposalOrderHeader = ({
    proposalId,
    status,
    onSave,
    isSaving = false,
    canEdit = true,
    isAlreadyOrdered = false,
    isCancelled = false,
    isLoading = false,
}) => {
    const navigate = useNavigate();

    // Determine badge styling based on status
    const renderStatusBadge = () => {
        if (isLoading) {
            return (
                <span className="inline-block w-28 h-8 bg-[#8B2433]/10 animate-pulse rounded-full" />
            );
        }

        const s = String(status || "").trim().toUpperCase();
        if (!s) return null;

        let badgeClass = "bg-gray-50 text-gray-800 border-gray-200 shadow-xs";
        let dotClass = "bg-gray-400";

        if (s === "ORDERED") {
            badgeClass = "bg-gradient-to-r from-emerald-50 via-[#e6fbf1] to-[#d1fae5]/80 text-[#047857] border-emerald-300 shadow-[0_2px_10px_rgba(16,185,129,0.18)]";
            dotClass = "bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.8)]";
        } else if (s === "ACCEPTED") {
            badgeClass = "bg-gradient-to-r from-purple-50 via-[#faf5ff] to-[#edd8ff]/80 text-[#6b21a8] border-purple-300 shadow-[0_2px_10px_rgba(168,85,247,0.18)]";
            dotClass = "bg-purple-500 shadow-[0_0_8px_rgba(168,85,247,0.8)]";
        } else if (s === "PENDING") {
            badgeClass = "bg-gradient-to-r from-amber-50 via-[#fffbeb] to-[#fde68a]/80 text-[#b45309] border-amber-300 shadow-[0_2px_10px_rgba(245,158,11,0.18)]";
            dotClass = "bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.8)]";
        } else if (s === "CANCELLED") {
            badgeClass = "bg-gradient-to-r from-rose-50 via-[#fff1f2] to-[#fecdd3]/80 text-[#be123c] border-rose-300 shadow-[0_2px_10px_rgba(244,63,94,0.18)]";
            dotClass = "bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.8)]";
        }

        return (
            <span className={`inline-flex items-center gap-2.5 px-4 py-1.5 sm:py-2 text-xs sm:text-[13.5px] font-bold tracking-wider uppercase rounded-full border-[1.5px] poppins-semibold transition-all ${badgeClass}`}>
                <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${dotClass}`} />
                <span>{s}</span>
            </span>
        );
    };

    return (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
            <div className="flex flex-col gap-1">
                <div className="flex items-center gap-3 flex-wrap">
                    <div className="w-10 h-10 rounded-xl bg-[#8B2433]/10 border border-[#8B2433]/20 flex items-center justify-center shrink-0">
                        <RiShoppingBag3Line className="w-5 h-5 text-[#8B2433]" />
                    </div>
                    <div className="flex items-center gap-3 flex-wrap">
                        <h2 className="text-2xl sm:text-3xl font-bold poppins-medium text-[#303030]">
                            Riepilogo Ordine
                        </h2>
                        {renderStatusBadge()}
                    </div>
                </div>
            </div>

            {/* Action Buttons: Conferma Ordine + Torna indietro */}
            <div className="flex items-center gap-3 self-start sm:self-auto flex-wrap">
                {canEdit && !isLoading && !isAlreadyOrdered && !isCancelled && (
                    <button
                        type="button"
                        onClick={onSave}
                        disabled={isSaving}
                        className="rounded-full py-[6px] border-[2px] bg-[#8B2433] border-[#8B2433] px-5 text-white text-sm font-semibold shadow-xs poppins-medium whitespace-nowrap hover:bg-[#721c29] hover:border-[#721c29] transition-all cursor-pointer flex items-center gap-1.5 disabled:opacity-50 disabled:cursor-not-allowed group"
                    >
                        <TiTick className="w-5 h-5 text-white shrink-0" />
                        <span>Conferma Ordine</span>
                    </button>
                )}

                <button
                    type="button"
                    onClick={() => navigate('/admin/proposals')}
                    className="rounded-full py-[6px] border-[2px] bg-[#fff] border-[#F2C3CA] px-5 text-[#8B2433] text-sm font-medium shadow-sm poppins-regular whitespace-nowrap shrink-0 hover:bg-[#8B2433] hover:text-white transition-colors cursor-pointer"
                >
                    Torna indietro
                </button>
            </div>
        </div>
    );
};

ProposalOrderHeader.propTypes = {
    proposalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
    onSave: PropTypes.func,
    isSaving: PropTypes.bool,
    canEdit: PropTypes.bool,
    isAlreadyOrdered: PropTypes.bool,
    isCancelled: PropTypes.bool,
    isLoading: PropTypes.bool,
};

export default ProposalOrderHeader;

